import styled from 'styled-components';

export const StyledFooter = styled.footer<{ $backgroundImage: string }>`
	width: 100%;
	min-height: 440px;
	padding: 24px;
	background-image: url("${({ $backgroundImage }) => $backgroundImage}");
	background-size: cover;
	background-position: top;
	background-repeat: no-repeat;
	background-color: #f4fafb;
	display: flex; 
	flex-direction: column; 
	justify-content: flex-end; 
	align-items: center; 
	box-sizing: border-box; 

	@media (max-width: 768px) {
		padding: 16px;
	}

	@media (max-width: 480px) {
		padding: 8px;
	}
`;

export const FooterContent = styled.div`
	display: flex;
	justify-content: space-between; 
	align-items: flex-end; 
	width: 100%;

	padding: 24px 6vw; 
	margin-top: auto; 

	@media (max-width: 768px) {
		padding: 16px 4vw;
	}

	@media (max-width: 480px) {
		padding: 12px 3vw;
	}
`;

export const LogoAddressContainer = styled.div`
	display: flex;
	flex-direction: column; 
	align-items: flex-start; 
	gap: 16px; 
`;

export const LogosContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px; 
`;

export const LogoImage = styled.img`
	height: 50px; 
	width: auto;
`;

export const Address = styled.p`
	font-size: 14px;
	color: #fff; 
	text-align: left; 
	margin: 0; 
`;

export const AuthContainer = styled.div`

`;

export const StyledButton = styled.button`
	background-color: transparent; 
	border: 1px solid #fff; 
	color: #fff; 
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;

	&:hover {
		background-color: rgba(
			255,
			255,
			255,
			0.1
		); 
	}
`;
